import { render, staticRenderFns } from "./marketplace_setup.vue?vue&type=template&id=90ad4b54&"
import script from "./marketplace_setup.vue?vue&type=script&lang=js&"
export * from "./marketplace_setup.vue?vue&type=script&lang=js&"
import style0 from "./marketplace_setup.vue?vue&type=style&index=0&id=90ad4b54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports